import { Chip } from "@mui/material";
import ToolTip from "../../../ToolTip/ToolTip";
import { render } from "@testing-library/react";

export const Batch_View_Table_Head = [
  {
    field: "sl_no",
    minWidth: 100,
    headerName: "Sl No",
  },
  {
    field: "course_batch_id",
    minWidth: 100,
    headerName: "Batch ID",
  },
  {
    field: "course_batch_name",
    minWidth: 250,
    headerName: "Batch Name",
    renderCell: (params) => {
      return (
        <ToolTip
          content={`${params.row.course_batch_name} - (${params.row.course_batch_serial_no})`}
          expand={`${params.row.course_batch_name} - (${params.row.course_batch_serial_no})`}
        />
      );
    },
  },
  {
    field: "courseAvailable",
    minWidth: 250,
    headerName: "Course",
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.courseAvailable}
          content={params.row.courseAvailable}
        />
      );
    },
  },
  {
    field: "className",
    minWidth: 150,
    headerName: "Class",
  },
  {
    field: "syllabusName",
    minWidth: 200,
    headerName: "Syllabus",
  },
  {
    field: "course_batch_capacity",
    minWidth: 150,
    headerName: "Capacity",
  },
  {
    field: "course_batch_start_date",
    minWidth: 200,
    headerName: "Start Date",
  },
  {
    field: "course_batch_start_time",
    minWidth: 200,
    headerName: "Start Time",
  },
  {
    field: "course_batch_end_time",
    minWidth: 200,
    headerName: "End Time",
  },
  {
    field: "createdBy",
    minWidth: 200,
    headerName: "Created By",
  },
  {
    field: "AssignedTo",
    minWidth: 200,
    headerName: "Assigned CRO",
    renderCell: (params) => {
      if (params.row.AssignedTo === null) {
        return (
          <Chip
            label="Not Assigned"
            variant="outlined"
            color="primary"
            size="small"
          />
        );
      } else {
        return params.row.AssignedTo;
      }
    },
  },
  {
    field: "AssignedBy",
    minWidth: 200,
    headerName: "Assigned CRM",
    renderCell: (params) => {
      if (params.row.AssignedBy === null) {
        return (
          <Chip
            label="Not Assigned"
            variant="outlined"
            color="primary"
            size="small"
          />
        );
      } else {
        return params.row.AssignedBy;
      }
    },
  },
  {
    field: "cro_assigned_on",
    minWidth: 200,
    headerName: "CRO Assigned On",
    renderCell: (params) => {
      return params.row.cro_assigned_on === null
        ? "Not Assigned"
        : params.row.cro_assigned_on;
    },
  },
  {
    field: "AssignedSME",
    minWidth: 200,
    headerName: "Assigned SME",
    renderCell: (params) => {
      if (params.row.AssignedSME === null) {
        return (
          <Chip
            color="primary"
            label={"Not Assigned"}
            size="small"
            variant="outlined"
          />
        );
      } else {
        return params.row.AssignedSME;
      }
    },
  },
  {
    field: "AssignedSMO",
    minWidth: 200,
    headerName: "Assigned SMO",
    renderCell: (params) => {
      if (params.row.AssignedSMO === null) {
        return (
          <Chip
            label="Not Assigned"
            size="small"
            variant="outlined"
            color="primary"
          />
        );
      } else {
        return params.row.AssignedSMO;
      }
    },
  },
  {
    field: "netWorth",
    minWidth: 200,
    headerName: "Total Batch Networth",
  },
  {
    field: "collectedAmount",
    minWidth: 200,
    headerName: "Collected Amount",
  },
  {
    field: "totalsessionandcompletedsession",
    minWidth: 200,
    headerName: "Completed Sessions / Total Sessions",
    renderCell: (params) => {
      return `${params.row.completedSessions} / ${params.row.totalSessions}`;
    },
  },
  {
    field: "totalTP",
    minWidth: 180,
    headerName: "TP Spent Till Now",
    renderCell: (params) => Math.round(Number(params.row.totalTP || 0)).toLocaleString("en-IN"),
  },
  {
    field: "avgTPPerSession",
    minWidth: 180,
    headerName: "Avg TP / Session",
    renderCell: (params) => Math.round(Number(params.row.avgTPPerSession || 0)).toLocaleString("en-IN"),
  },
  {
    field: "courseBatchStatus",
    minWidth: 200,
    headerName: "Status",
    renderCell: (params) => {
      if (params.row.courseBatchStatus === "Active") {
        return (
          <Chip
            color="primary"
            label="Active"
            size="small"
            variant="outlined"
          />
        );
      } else if (params.row.courseBatchStatus === "Temporary Inactive") {
        return (
          <Chip
            color="warning"
            label="Temporary Inactive"
            size="small"
            variant="outlined"
          />
        );
      } else if (params.row.courseBatchStatus === "Upcoming") {
        return (
          <Chip
            color="secondary"
            label="Upcoming"
            size="small"
            variant="outlined"
          />
        );
      } else {
        return (
          <Chip
            color="success"
            label="Completed"
            size="small"
            variant="outlined"
          />
        );
      }
    },
  },
];
